import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有租赁单位信息
export const unitList = (getData) => {
  return request({
    url: '/inspect-unit/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}

// 根据id删除
export const deleteById = (getData) => {
  return request({
    url: '/inspect-unit/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 根据id修改状态
export const updateStatus = (getData) => {
  return request({
    url: '/inspect-unit/updateStatus',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改单位信息
export const updateById = (postData) => {
  return request({
    url: 'inspect-unit/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 新增单位信息
export const addUnit = (postData) => {
  return request({
    url: 'inspect-unit/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//租赁单位
export const queryUnit = (postData) => {
  return request({
    url: '/inspect/queryOriginalUnit',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
